import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect } from "react";

const GoogleResponsiveAd = ({ sx }) => {
  //   useEffect(() => {
  //     // Load the AdSense script only once
  //     const script = document.createElement("script");
  //     script.src =
  //       "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8494214289237817";
  //     script.async = true;
  //     script.crossOrigin = "anonymous";
  //     document.body.appendChild(script);

  //     // Push ad rendering after the script is loaded
  //     script.onload = () => {
  //       (window.adsbygoogle = window.adsbygoogle || []).push({});
  //     };
  //   }, []);

  return (
    <Box
      sx={{
        flex: 1,
        position: "relative",
        minHeight: "inherit",
        height: "inherit",
        width: "100%",
        ...sx,
      }}
    >
      {/* LOADING IN BG */}
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: "100%",
          display: "flex",
          minHeight: "inherit",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography p={2}>
          Loading Google Ads{" "}
          <CircularProgress color="inherit" size="15px" sx={{ ml: 1 }} />
        </Typography>
      </Box>
      {/* gOOGLE AD */}
      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          minHeight: "inherit",
          height: "inherit",
          //   background: "red",
          zIndex: 1,
          position: "relative",
        }}
        data-ad-client="ca-pub-8494214289237817"
        data-ad-slot="9175274099"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>

      {/* Sponser label */}
      <Box
        sx={{
          position: "absolute",
          top: 8,
          left: 8,
          bgcolor: "rgba(0, 0, 0, 0.7)",
          color: "white",
          px: 1,
          py: 0.5,
          borderRadius: 1,
          zIndex: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontSize: "10px", fontWeight: 500 }}
        >
          PROMOTIONAL
        </Typography>
      </Box>
    </Box>
  );
};

export default GoogleResponsiveAd;

//    {/* <Typography mx="auto" width="250px" textAlign="right">
//             <CircularProgress /> LOADING AD...
//           </Typography> */}
//           {/* <ins
//             className="adsbygoogle"
//             style={{
//               display: "block",
//               width: "100%",
//               height: "100%",
//               // "250px",

//               minHeight: isMobile
//                 ? `calc(99dvh - ${NAV.MOBILE}px)`
//                 : `calc(100vh - ${HEADER.H_DESKTOP + 150}px )`,
//             }}
//             data-ad-client="ca-pub-8494214289237817"
//             data-ad-slot="1279441620"
//             data-ad-format="auto"
//             data-full-width-responsive="true"
//           /> */}

//           {/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8494214289237817"
//      crossorigin="anonymous"></script>
// <!-- multi-dimensional -->
// <ins class="adsbygoogle"
//      style="display:block"
//      data-ad-client="ca-pub-8494214289237817"
//      data-ad-slot="9175274099"
//      data-ad-format="auto"
//      data-full-width-responsive="true"></ins>
// <script>
//      (adsbygoogle = window.adsbygoogle || []).push({});
// </script> */}
